import { Dispatch } from 'redux';
import { LoginService } from '../services/LoginService';


export const fetchData1 = (reset: any) => ({
    type: 'FETCH_RESET_SUCCESS',
    payload: reset,
});





export const ResetPassword = (opass:any,repass:any,rpass:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {opass:opass,repass:repass,rpass:rpass,uid:uid}
            const apiname = '/ws_an_reset.php';
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData1(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};




